import { useDndContext, useDroppable } from '@dnd-kit/core'
import TableComponent from '../../../../../../../components/stories/organisms/table'
import {
  canDropItemsToRoot,
  getActiveItem,
  getItemsToMove,
  projectMenuDropTargetTypeOptions
} from '../utils'

const CompanyProjectsTableContent = ({
  children,
  rowSelection,
  rowsById,
  table
}) => {
  const { active, over } = useDndContext()
  const activeItem = getActiveItem(active, rowsById)
  const itemsToMove = getItemsToMove({ activeItem, rowSelection, rowsById })
  const canDropToRoot = canDropItemsToRoot(itemsToMove)
  const activeDropTargetType = over?.data.current?.type
  const isRootDropTargetActive = [
    projectMenuDropTargetTypeOptions.ROOT,
    projectMenuDropTargetTypeOptions.ROOT_ROW
  ].includes(activeDropTargetType)
  const isRootDropHighlighted = canDropToRoot && isRootDropTargetActive

  const { setNodeRef } = useDroppable({
    id: 'project-menu-root-drop-zone',
    data: { type: projectMenuDropTargetTypeOptions.ROOT },
    disabled: !canDropToRoot
  })

  return (
    <TableComponent.Content
      rowSelection={rowSelection}
      table={table}
      tableRef={setNodeRef}
      style={{ borderRadius: `0px 0px 16px 16px` }}
      dndState={{
        canDrop: canDropToRoot,
        isDroppable: canDropToRoot,
        isOver: isRootDropHighlighted
      }}
    >
      {children}
    </TableComponent.Content>
  )
}

export default CompanyProjectsTableContent
